<template>
  <div class="container">
    <img src="https://qn.lavamusic.com/h5-images/20221024%2811%29.png" alt="" />
    <p @click="toTB" style="top: 14.17%;">
    </p>
  </div>
</template>
<script>
import dsBridge from "dsbridge";
export default {
  name: "TB20221024",
  setup() {
    const toTB = () => {
      const ua = navigator.userAgent;
      if (ua.includes("LAVA")) {
        dsBridge.call("openAction", {
          pageType: 5,
          url: "https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4",
        });
      } else {
        const a = document.createElement("a");
        a.setAttribute(
          "href",
          "https://shop.m.taobao.com/shop/sr.htm?p=2Ik4Hv_80XeE_0_onyw4"
        );
        a.click();
        console.log(a);
        a.remove();
      }
    };
    return {toTB};
  },
};
</script>
<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  height: auto;
  // background: #fef8cf;
}

.container > img {
  width: 100%;
  vertical-align: middle;
  object-fit: fill;
}

.container > p {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 7.3vw;
  width: 26vw;
  border-radius: 3.5vw;
  text-align: center;
}

.container > p > a {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
